import { render, staticRenderFns } from "./LiteratureMinigame.vue?vue&type=template&id=14633914&scoped=true"
import script from "./LiteratureMinigame.vue?vue&type=script&lang=js"
export * from "./LiteratureMinigame.vue?vue&type=script&lang=js"
import style0 from "./LiteratureMinigame.vue?vue&type=style&index=0&id=14633914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14633914",
  null
  
)

export default component.exports